import { ref } from 'vue'

/**
 *
 * 返回数字
 */
function toPosInt(value: number | string): number {
  const number = +value
  if (isNaN(number)) {
    return 0
  }
  return Math.round(number)
}

/**
 * 判断两个数值，如果大于0.1，则认为是不相等的
 */
function judgeNotCloseEnough(value1: number, value2: number) {
  return Math.abs(value1 - value2) > 0.1
}

function genXY(
  left: number | string,
  top: number | string,
  width: number | string,
  height: number | string
) {
  const x1 = toPosInt(left)
  const y1 = toPosInt(top)
  const w = toPosInt(width)
  const h = toPosInt(height)
  return {
    x1,
    y1,
    x2: x1 + w,
    y2: y1 + h
  }
}

const areaInfo = ref({
  xmin: null,
  ymin: null,
  xmax: null,
  ymax: null
})
function judgeAreaFn(list: Widget[]) {
  let xmin = null,
    ymin = null,
    xmax = null,
    ymax = null
  for (const item of list) {
    const { left, top, width, height } = item.styleProp
    const { x1, y1, x2, y2 } = genXY(left, top, width, height)
    if (xmin > x1 || xmin === null) {
      xmin = x1
    }
    if (ymin > y1 || ymin === null) {
      ymin = y1
    }
    if (xmax < x2 || xmax === null) {
      xmax = x2
    }
    if (ymax < y2 || ymax === null) {
      ymax = y2
    }
  }
  areaInfo.value = { xmin, ymin, xmax, ymax }
}
function alignFn(type: string, list: Widget[]) {
  const { xmin, ymin, xmax, ymax } = areaInfo.value
  // console.log('alignFn', type, xmin, ymin, xmax, ymax)
  switch (type) {
    case 'align-top':
      for (const item of list) {
        const { styleProp } = item
        styleProp.top = ymin
      }
      break
    case 'align-vertical-center':
      for (const item of list) {
        const { styleProp } = item
        const h = toPosInt(styleProp.height)
        const calcTop = ymin + toPosInt((ymax - ymin - h) / 2)
        styleProp.top = calcTop
      }
      break
    case 'align-bottom':
      for (const item of list) {
        const { styleProp } = item
        const top = toPosInt(styleProp.top)
        const h = toPosInt(styleProp.height)
        const calcTop = ymax - h
        if (judgeNotCloseEnough(top, calcTop)) {
          styleProp.top = calcTop
        }
      }
      break
    case 'align-left':
      for (const item of list) {
        const { styleProp } = item
        styleProp.left = xmin
      }
      break
    case 'align-horizontal-center':
      for (const item of list) {
        const { styleProp } = item
        const w = toPosInt(styleProp.width)
        const calcLeft = xmin + toPosInt((xmax - xmin - w) / 2)
        styleProp.left = calcLeft
      }
      break
    case 'align-right':
      for (const item of list) {
        const { styleProp } = item
        const left = toPosInt(styleProp.left)
        const w = toPosInt(styleProp.width)
        const calcLeft = xmax - w
        if (judgeNotCloseEnough(left, calcLeft)) {
          styleProp.left = calcLeft
        }
      }
      break
    default:
      break
  }
}
function rangeFn(type: string, list: Widget[]) {
  const { xmin, ymin, xmax, ymax } = areaInfo.value
  // console.log('rangeFn', type, xmin, ymin, xmax, ymax)
  switch (type) {
    case 'horizontal-distribution':
      {
        let laveWidth = 0,
          contentWidth = 0,
          equalWidth = 0
        const len = list.length
        for (const item of list) {
          const { styleProp } = item
          styleProp.left = toPosInt(styleProp.left)
          styleProp.width = toPosInt(styleProp.width)
          contentWidth += styleProp.width
        }
        laveWidth = xmax - xmin - contentWidth
        if (laveWidth <= 0) {
          break
        }
        equalWidth = laveWidth / (len - 1)
        const sortList = list.sort((a, b) => {
          return a.styleProp.left - b.styleProp.left
        })
        for (let ix = 1; ix < len; ix++) {
          const { styleProp } = sortList[ix]
          const prevItem = sortList[ix - 1]
          styleProp.left = prevItem.styleProp.left + prevItem.styleProp.width + equalWidth
        }
      }
      break
    case 'vertical-distribution':
      {
        let laveHeight = 0,
          contentHeight = 0,
          equalHeight = 0
        const len = list.length
        for (const item of list) {
          const { styleProp } = item
          styleProp.top = toPosInt(styleProp.top)
          styleProp.height = toPosInt(styleProp.height)
          contentHeight += styleProp.height
        }
        laveHeight = ymax - ymin - contentHeight
        if (laveHeight <= 0) {
          break
        }
        equalHeight = laveHeight / (len - 1)
        const sortList = list.sort((a, b) => {
          return a.styleProp.top - b.styleProp.top
        })
        for (let ix = 1; ix < len; ix++) {
          const { styleProp } = sortList[ix]
          const prevItem = sortList[ix - 1]
          styleProp.top = prevItem.styleProp.top + prevItem.styleProp.height + equalHeight
        }
      }
      break
    default:
      break
  }
}

export function useArea() {
  return {
    areaInfo,
    judgeAreaFn,
    alignFn,
    rangeFn
  }
}
